// src/js/config/configLoader.js

import { CONFIG_KEY_PREFIX } from './constants.js';

export function getAllOrderConfigs() {
    const savedConfigs = [];
    const localStoragePrefix = CONFIG_KEY_PREFIX;

    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key.startsWith(localStoragePrefix)) {
            try {
                const storedData = localStorage.getItem(key);
                const configData = JSON.parse(storedData);
                if (configData && typeof configData === 'object' && configData.name) {
                    const id = key.substring(localStoragePrefix.length);
                    savedConfigs.push({ id: id, name: configData.name });
                }
            } catch (e) {
                console.error(`Fel vid tolkning av Local Storage-data för nyckel ${key}:`, e);
            }
        }
    }
    return savedConfigs;
};

export async function loadConfigData(sourceType, valueOrFile) {
    const strings = window.SimP_Strings || {};
    const localStoragePrefix = CONFIG_KEY_PREFIX; 
    
    try {
        let configData = null;
        let configName = "Unknown";

        if (sourceType === 'select') {
            const selectedValue = valueOrFile;
            if (selectedValue === "default" || !selectedValue) {
                return { success: false, isWarning: true, message: strings.load_config_loader_warning_select_config || "Välj en konfiguration." };
            }
            const configKey = `${localStoragePrefix}${selectedValue}`;
            const storedData = localStorage.getItem(configKey);
            configData = JSON.parse(storedData);
            configName = configData?.name || selectedValue;

        } else if (sourceType === 'upload') {
            const file = valueOrFile;
            if (!file) {
                return { success: false, isWarning: true, message: strings.load_config_loader_warning_choose_file || "Välj en fil." };
            }
            const fileContent = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = (e) => reject(new Error(strings.load_config_error_read_file || "Kunde inte läsa filen"));
                // ### DENNA RAD VAR DEN SOM SAKNADES ###
                reader.readAsText(file);
            });
            configData = JSON.parse(fileContent);
            configName = file.name;
        }

        if (!configData || typeof configData !== 'object' || !configData.features || typeof configData.features !== 'object' || Array.isArray(configData.features)) {
            return { success: false, message: strings.load_config_error_invalid_format || "Filen har ett ogiltigt format." };
        }

        return { success: true, data: { configData, configName } };

    } catch (error) {
        console.warn("Ett fel inträffade i loadConfigData:", error.message);
        const errorString = sourceType === 'select' ? strings.load_config_error_parsing_localstorage : strings.load_config_error_parsing_file;
        return { success: false, message: errorString || "Kunde inte tolka filens innehåll. Kontrollera att det är en giltig konfigurationsfil." };
    }
}